<template>
  <el-row>

    <div class="bannerImg"></div>
    <el-row style="clear:both;min-height:20px;text-align:left">
    </el-row>
    <el-upload class="upload" :show-file-list=false drag :before-upload="uploadWord" :on-success="wordUpSucc"
      accept=".doc,.docx" action="/webApi/v3/robot/uploadWord">
      <div class="uploadFile"></div>
      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em>
        <div class="desc t_c">支持拓展名：doc、docx</div>
      </div>

    </el-upload>
    <div class="desc" style="top:0px">小弈将根据您推荐的内容自动推荐相关素材</div>
  </el-row>
</template>

<script>
import Loading from '../js/Loading.vue'
export default {
  name: 'index',
  data: function () {
    return {

      exportContent: '',
      ruleForm: {
        exportContent: ''
      },
      rules: {
        exportContent: [
          { required: true, message: '请输入导入的内容', trigger: 'blur' },
          { min: 50, max: 2000, message: '长度在 50 到 2000 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {

    // 跳转到详情页
    goDetail (articleId) {
      if (articleId) {
        this.$router.push({ path: '/newsEdit', query: { articleId: articleId, from: 'txt' } })
      } else {
        _this.$message.error('写作失败，请换个词试试');
      }
    },

    genArticle () {
      let _this = this
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.axios.postWithLoading('/webApi/v3/robot/uploadContent', { 'title': '', 'content': _this.ruleForm.exportContent }).then((response) => {
            if (response.data.autoNewsId) {
              _this.goDetail(response.data.autoNewsId)
            } else {
              this.$message.error('未写作成功，请编辑内容后重试');
            }
          })
        }
      })
    },
    wordUpSucc (response, file, fileList) {
      Loading.stopLoading()
      let _this = this
      if (response.code === 200) {
        if (response.data.autoNewsId) {
          _this.goDetail(response.data.autoNewsId)
        } else {
          this.$message.error('未写作成功，请编辑内容后重试');
        }
      } else {
        this.$message.error(response.msg);
      }
    },
    uploadWord () {
      Loading.startLoading('弈写正在努力写作中，请稍等...')
    }

  },
  components: {

  },
  mounted () {

  },
  watch: {

  }
}
</script>

<style lang="less" scoped>
.bannerImg {
  background-image: url('../../assets/imgs/importWordBanner.png');
}
</style>



// WEBPACK FOOTER //
// src/components/write/importWorld.vue